































import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';

export default Vue.component('custom-dropdown-control', {
  name: 'EntityControl',
  props: {
    'entity-name': {
      type: String,
      default: ''
    },
    'name-to-display': {
      type: String,
      default: ''
    },
    'entity-get-api': {
      type: String,
      default: ''
    },
    'entity-items': {
      type: Array,
      default: () => { return [] }
    },
  },
  data () {
    return {
      showDropdown: false,
      loadingSearchData: false,
      searchInput: (this as any).nameToDisplay,
      performSearchTimeout: null as any,
      searchData: [] as any[],
      searchResults: [] as any[],
      searchCountResults: 0,
      allowForceResultsMaximum: 150,
      allowForceResults: false,
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  methods: {
    async searchEntities (searchInput: string) {
      if (!this.searchData.length) {
        try {
          const entityItems = (this as any).entityItems;
          if (entityItems && entityItems.length) {
            this.searchData = entityItems.map( (item: any) => { item.nameUpperCase = item.name.toUpperCase(); return item; } );
          } else if ((this as any).entityGetApi) {
            await this.loadSearchData((this as any).entityGetApi);
          }
        } catch (err) {}
      }

      const searchInputUppercase = searchInput.toUpperCase();
      let tempMatch = [];
      for (let i=0; i < this.searchData.length; i++) {
        if (this.searchData[i].nameUpperCase.indexOf(searchInputUppercase) !== -1) {
          tempMatch.push(this.searchData[i]);
        }
      }
      this.searchCountResults = tempMatch.length;
      this.allowForceResults = tempMatch.length < this.allowForceResultsMaximum;
      this.searchResults = tempMatch;
    },

    loadSearchData (api: any) {
      return new Promise( (resolve, reject) => {

        let self = this;
        self.loadingSearchData = true;
        HTTP.get(api)
        .then(function (response) {
          if (!response.data || !response.data.data) { throw new Error("Error retrieving results."); }
          self.searchData = response.data.data.map( (item: any) => { item.nameUpperCase = item.name.toUpperCase(); return item; } );
          self.loadingSearchData = false;
          resolve();
        })
        .catch(function () {
          self.loadingSearchData = false;

          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Getting Results',
            text: 'Something went wrong getting search results!',
          });
          reject();
        })

      });
    },
    selectEntity (entity: any) {
      this.$emit('selected', {id: entity.id, name: entity.name} );
      this.showDropdown = false;
    },
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
      if (this.showDropdown) {
        this.searchInput = '';
        // tslint:disable-next-line:no-floating-promises
        this.searchEntities(this.searchInput);

        // This timeout needs to occure because of the "transition" effect on making the dropdown appear visible from "visibility:hidden".
        // The transition is 300 milliseconds, so this timeout set to greater than about 100ms to allow time for the input element to
        // become visibile before focusing.
        setTimeout(() => {
          (this.$refs.search as any).focus();
          (this.$refs.search as any).select();
        }, 300);
      }
    },

  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/CustomDropdownControl.vue